import React from "react";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
// import { fetchIntegrationToken } from "../helper/api";
import { setUserSubscriptionData } from "../helper/hooks";

export const GlobalComponent = props => {
  const member = useSelector(state => get(state, ["member"], null));
  const dispatch = useDispatch();

  React.useEffect(() => {
    // fetchIntegrationToken(dispatch);
  }, [member]);

  React.useEffect(() => {
    // fetchIntegrationToken(dispatch);
    setUserSubscriptionData(dispatch);
  }, []);

  return <React.Fragment />;
};
